import Vue        from 'vue';
import Vuex       from 'vuex';
import jwtDecode  from 'jwt-decode';

// load modules
import clientModule from './modules/client';
import brokerModule from './modules/broker';
import plannerModule from './modules/planner';
import leadModule   from './modules/lead';

Vue.use(Vuex);

function isLoggedIn() {
  // console.log(moment().format("dddd, MMMM Do YYYY, h:mm:ss a"))
  let jwt = localStorage.getItem('bp-broker-jwt');

  if(jwt !== null) {
    let jwtObj = jwtDecode(jwt);
    // console.log(moment.unix(jwtObj.iat).format("dddd, MMMM Do YYYY, h:mm:ss a"))
    return localStorage.getItem('bp-broker-jwt') !== null
  }

  return false;
}

export const store = new Vuex.Store({

  modules : {
    clientModule,
    brokerModule,
    plannerModule,
    leadModule
  },

	strict : true,

  state : {

    // there are 2 views for admin i.e 'brokerpad' and 'plannerpad'
    adminView : null,
    
    view: null,

    // current logged in user
    user: null,

    // required fields for the application form
    requiredFields : null,

    // for search query
    emptyQueryIndicator : 'ZmM4rtgJE8',

    // let's set some widths for various components
    // not sure if this is the best place to set these
    // constants, but... for now.. it'll do
    sizes : {
      headerHeight               : 95,
      navigationWidth            : 200,
      adminNavigationWidth       : 220,
      applicantNavigationWidth   : 220,
    },

    isMobileMenuOpen: false,
    isLoggedIn      : isLoggedIn(),
    loginError      : null,
    loginMessage    : null,
    redirectUrl     : null,
  },

  mutations: {

    setAdminView(state, adminView) {
      state.adminView = adminView;
    },

    setView(state, view) {
      state.view = view;
    },

    setRequiredFields(state, rfs) {
      state.requiredFields = rfs;
    },

    setIsMobileMenuOpen(state, value) {
      state.isMobileMenuOpen = value;
    },

    setIsLoggedIn(state, loggedIn) {
      state.isLoggedIn = loggedIn;
      state.loginError = null;

      if(!loggedIn) {
        state.user = null;
      }
    },

    setLoginError(state, error) {
      state.isLoggedIn = false;
      state.loginError = error;
    },

    setLoginMessage(state, message) {
      state.loginMessage = message;
    },

    setRedirectUrl(state, redirectUrl) {
      state.redirectUrl = redirectUrl;
    },

    setUser(state, user) {
      state.user = user;
    },

    setUserProperty(state, params) {
      state.user[params.key] = params.value;
    },
  },

});
